import {
  Directive,
  Host,
  Input,
  AfterViewInit,
  OnDestroy,
  OnInit,
  Renderer2,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { PgInputDirective } from './pg-input.directive';
import { Subscription } from 'rxjs';

const DEFAULT_TIMEOUT = 60000;

export function unfocus(): any {
  const tmp: HTMLInputElement = document.createElement('input');
  //tmp.style.display = 'none';
  document.body.appendChild(tmp);
  tmp.focus();
  document.body.removeChild(tmp);
}

@Directive({
  selector: '[pgSecureInput], [gritSecureInput]',
  exportAs: 'pgSecureInput, gritSecureInput',
})
export class PgSecureInputDirective
  implements OnInit, AfterViewInit, OnDestroy {
  @Input() pgSecureInput: number;

  get timeoutDuration() {
    return this.pgSecureInput;
  }

  inputSub: Subscription;
  timeoutRef: any;
  handler: Function;

  get remainingTimeUntilSecure() {
    if (!this._timerStart) {
      return 0;
    }
    if (this._secureState !== 'counting') {
      return 0;
    }
    return Math.max(
      0,
      this.timeoutDuration - (new Date().getTime() - this._timerStart)
    );
  }
  _timerStart;

  get isSecure() {
    return this.secureState === 'secure';
  }

  @Output()
  secureStateChange = new EventEmitter<string>();
  get secureState() {
    return this._secureState;
  }
  set secureState(state) {
    this._secureState = state;
    this.secureStateChange.emit(state);
  }
  _secureState: 'pristine' | 'secure' | 'counting' = 'pristine';

  get hostEl(): HTMLElement {
    return this._elementRef.nativeElement;
  }
  constructor(
    @Host() private _input: PgInputDirective,
    private _elementRef: ElementRef,
    private _renderer: Renderer2
  ) {}

  ngOnInit() {
    if (!this.pgSecureInput) {
      this.pgSecureInput = DEFAULT_TIMEOUT;
    }
  }
  ngAfterViewInit(): void {
    this.inputSub = this._input.stateChanges.subscribe(() => {
      if (this.secureState === 'pristine' && this._input.value) {
        this.secureState = 'counting';
        this._startTimer();
      } else if (this.secureState === 'counting') {
        this._startTimer();
      }
    });
  }

  ngOnDestroy() {
    this.inputSub.unsubscribe();
    if (this.handler) {
      this.handler();
    }
  }

  private _startTimer() {
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
    }
    this.timeoutRef = setTimeout(() => {
      this._setSecure();
    }, this.timeoutDuration);
    this._timerStart = new Date().getTime();
  }

  private _setSecure() {
    this.secureState = 'secure';
    this._input.secure = true;
    unfocus();
    this.handler = this._renderer.listen(this.hostEl, 'focus', () => {
      this._setPristine();
      this.handler();
    });
  }

  private _setPristine() {
    this._input.value = '';
    this._input.secure = false;
    this.secureState = 'pristine';
  }
}

/* Questions for UX 
    In "secure mode" do we want to clear out content on focus?
    IF we reset to  pristine mode, do we want to  also set the form control to pristine?
  Do we want to wait on blur for the timer to start?
*/
